import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/home',
            name: 'home',
            component: () => import("./views/home.vue"),
            meta: {
                hasBar: true,
                closeAppModal: true
            }
        },
        {
            path: '/home/:identifier',
            name: 'home_identifier',
            component: () => import("./views/home.vue"),
            meta: {
                hasBar: false,
            }
        },
        {
            path: '/home/requestPayment',
            name: 'home_requestPayment',
            component: () => import("./views/requestPayment.vue"),
            meta: {
            }
        },
        {
            path: '/home/transferBalance',
            name: 'home_transferBalance',
            component: () => import("./views/transferBalance.vue"),
            meta: {
            }
        },
        {
            path: '/home/waitingCommissions',
            name: 'home_waitingCommissions',
            component: () => import("./views/waitingCommissions.vue"),
            meta: {
            }
        },
        {
            path: '/home/walletTransactions',
            name: 'home_walletTransactions',
            component: () => import("./views/walletTransactions.vue"),
            meta: {
            }
        },
        {
            path: '/datiPersonali',
            name: 'datiPersonali',
            component: () => import("./views/datiPersonali.vue"),
        },
    ];
};